import { turboproApi } from '@/api/turbopro';
import type { BuscarStatusSolicitacaoResponse } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function buscarStatusSolicitacaoApi(
  solicitacaoId: number
): Promise<BuscarStatusSolicitacaoResponse> {
  const resposta = await turboproApi<BuscarStatusSolicitacaoResponse>(
    `Relatorios/BuscarStatusSolicitacao?solicitacao_id=${solicitacaoId}`,
    { headers: getRelatoriosHeaders() }
  );
  return resposta.data;
}
